import { yupResolver } from "@hookform/resolvers/yup"
import {
  Button,
  LoadingOverlay,
  Modal,
  Select,
  Switch,
  Textarea,
  TextInput,
} from "@mantine/core"
import { DateInput } from "@mantine/dates"
import {
  IconCalendar,
  IconDeviceFloppy,
  IconEdit,
  IconHomePlus,
  IconTrash,
} from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import * as yup from "yup"
import { CollectionQuery } from "../../../models/collection.model"
import Confirmation from "../../../shared/component/confirmation/action-confirmation"
import EmptyIcon from "../../../shared/component/empty-icon/empty-icon"
import { Pagination } from "../../../shared/component/pagination/pagination"
import { dateFormat } from "../../../shared/utility/date-format/date-format"

import { useDisclosure } from "@mantine/hooks"
import dayjs from "dayjs"
import { motion } from "framer-motion"
import { t } from "i18next"
import { ManagementFeeIncrease } from "../../../models/management-fee-increase.model"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { useCreateManagementFeeIncreaseMutation, useDeleteManagementFeeIncreaseMutation, useLazyGetManagementFeeIncreasesQuery, useUpdateManagementFeeIncreaseMutation } from "../store/management-fee-increase.query"

type NewUnitComponentProps = {
  // lease: any;
  // open: any;
  // opened: boolean;
  // close: any;
}
export function ManagementFeeIncreaseComponent(props: NewUnitComponentProps) {
  const params = useParams()
  // let { open, opened, close } = props;
  const [opened, { open, close }] = useDisclosure()
  const [userInfo, tenantInfo] = useCurrentUser()
  const [mode, setMode] = useState<"new" | "edit">("new")
  const [type, setType] = useState<"Amount" | "Percent">("Amount")
  const [selectedManagementFeeIncrease, setSelectedManagementFeeIncrease] = useState<
    string | null
  >(null)
  const [propertySearch, setPropertySearch] = useState<string | null>(null)
  const [propertiesCollection, setPropertiesCollection] =
    useState<CollectionQuery>({
      top: 10,
      skip: 0,
    })
  const [managementFeeIncreaseCollection, setManagementFeeIncreaseCollection] =
    useState<CollectionQuery>({
      top: 10,
      skip: 0,
    })
  const [leaseCollection, setLeaseCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
    filter: [[{ field: "propertyId", value: params?.id as string }]],
  })
  const [createManagementFeeIncrease, createManagementFeeIncreaseResponse] =
    useCreateManagementFeeIncreaseMutation()
  const [updateManagementFeeIncrease, updateManagementFeeIncreaseResponse] =
    useUpdateManagementFeeIncreaseMutation()
  const [deleteManagementFeeIncrease, deleteManagementFeeIncreaseResponse] =
    useDeleteManagementFeeIncreaseMutation()
  // const [getProperties, properties] = useLazyGetPropertiesOfUnitQuery();
  const [getManagementFeeIncreases, managementFeeIncreases] = useLazyGetManagementFeeIncreasesQuery()

  const defaultValue: ManagementFeeIncrease = {
    //   increaseDate: null,
    increaseAmount: 0,
    increasePercentage: 0,
    reasonForIncrease: "",
    increaseDate: null,
    notifyTenant: false,
    // nextIncreaseDate: null,
    notes: "",
  }

  let schema: any = yup.object().shape({
    increaseAmount: yup.number().when([], {
      is: () => type == "Amount",
      then: (schema) =>
        schema
          .typeError(
            t("typeValidation", {
              field: t("increaseAmount"),
              type: t("number"),
            }),
          )
          .required(t("requiredValidation", { field: t("increaseAmount") })),
    }),
    increasePercentage: yup.number().when([], {
      is: () => type == "Percent",
      then: (schema) =>
        schema
          .typeError(
            t("typeValidation", {
              field: t("increasePercent"),
              type: t("number"),
            }),
          )
          .required(t("requiredValidation", { field: t("increasePercent") })),
    }),
    reasonForIncrease: yup
      .string()
      .typeError(
        t("typeValidation", {
          field: t("reasonForIncrease"),
          type: t("string"),
        }),
      )
      .required(t("requiredValidation", { field: t("reasonForIncrease") })),
    increaseDate: yup
      .date()
      .typeError(
        t("typeValidation", { field: t("increaseDate"), type: t("date") }),
      )
      .required(t("requiredValidation", { field: t("increaseDate") })),
    // increaseDate: yup.date().typeError("Increase date should be a date").required("Increase date is required"),
    notes: yup
      .string()
      .typeError(t("requiredValidation", { field: t("notes") })),
  })
  const {
    register,
    setValue,
    getValues,
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<ManagementFeeIncrease>({
    resolver: yupResolver(schema),
    mode: "all",
  })

  useEffect(() => {
    getManagementFeeIncreases({
      ...managementFeeIncreaseCollection,
      filter: [
        [{ field: "leaseId", value: params?.id as string, operator: "=" }],
      ],
    })
  }, [managementFeeIncreaseCollection, getManagementFeeIncreases, params])

  // useEffect(() => {
  //     getProperties({ ...propertiesCollection, filter: [[{ field: 'name', operator: 'like', value: propertySearch as string }]] });
  // }, [propertySearch])

  // useEffect(() => {
  //     getProperties(propertiesCollection)
  // }, [propertiesCollection])

  function onSubmit(data: any) {
    try {
      data = {
        ...data,
        increaseDate: dayjs(data?.increaseDate).format(),
        leaseId: params?.id as string,
      }

      if (mode == "new") {
        createManagementFeeIncrease(data).then((response: any) => {
          // if (!response?.error) {
          reset(defaultValue)
          close()
          // }
        })
      } else {
        updateManagementFeeIncrease({
          ...data,
          id: selectedManagementFeeIncrease as string,
        }).then((response: any) => {
          // if (!response?.error) {
          reset(defaultValue)
          close()
          // }
        })
      }
    } catch (e: any) {
      console.log("🚀 ~ onSubmit ~ e:", e)
    }
  }
  const onError = (error: any) => {
    console.log("🚀 ~ onError ~ error:", error)
  }

  // function _parseProperties() {
  //     let data: { label: string; value: string }[] = [];

  //     properties?.data?.data?.map((property: Property) => {
  //         data.push({ label: property?.name as string, value: property?.id as string });
  //     })

  //     return data;
  // }

  function openUpdateModal(managementFeeIncrease: ManagementFeeIncrease) {
    open()
    setSelectedManagementFeeIncrease(managementFeeIncrease?.id as string)
    setValue("increaseAmount", managementFeeIncrease.increaseAmount as number)
    setValue("increasePercentage", managementFeeIncrease.increasePercentage as number)
    setValue("reasonForIncrease", managementFeeIncrease.reasonForIncrease as string)
    setValue("increaseDate", new Date(managementFeeIncrease.increaseDate as Date))
    setValue("notifyTenant", managementFeeIncrease?.notifyTenant)
    setValue(
      "nextIncreaseDate",
      new Date(managementFeeIncrease.nextIncreaseDate as Date),
    )
    setValue("notes", managementFeeIncrease.notes as string)
    setMode("edit")
  }

  return (
    <>
      <div className="bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg shadow-lg rounded-xl p-6 border border-gray-700 mb-8">
        <LoadingOverlay
          visible={managementFeeIncreases?.isLoading || managementFeeIncreases?.isFetching}
        />

        <div className="flex w-full justify-end gap-2 mb-4">
          {userInfo?.role?.key !== "tenant" && (
            <Button
              variant="filled"
              loading={createManagementFeeIncreaseResponse?.isLoading}
              className={`bg-primary text-white flex space-x-2 items-center`}
              type="button"
              onClick={() => {
                open()
                reset(defaultValue)
                setMode("new")
              }}
              classNames={{ label: "flex space-x-1" }}
              size={"xs"}
            >
              <IconHomePlus size={20} strokeWidth={1.5} />{" "}
              {t("managementFeeIncreaseAction", { action: t("add") })}
            </Button>
          )}
        </div>

        <div className="px-2 overflow-x-auto relative">
          <table className="min-w-full divide-y divide-gray-700">
            <thead
            // className="text-xs text-gray-700 capitalize bg-gray-50 dark:bg-gray-700 dark:text-gray-400 "
            >
              <tr className="text-nowrap">
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("baseManagementFee")}
                </th>

                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("newManagementFeeAmount")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("increaseDate")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("increasePercent")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("increaseAmount")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("reasonForIncrease")}
                </th>
                {/* <th scope="col" className='px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider'>
                                    Next Increase Date
                                </th> */}
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("status")}
                </th>

                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  {t("registeredAt")}
                </th>
                {userInfo?.role?.key !== "tenant" && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    {t("action")}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {managementFeeIncreases?.data?.data &&
                managementFeeIncreases?.data?.data.length > 0 &&
                managementFeeIncreases?.data?.data.map(
                  (managementFeeIncrease: ManagementFeeIncrease, idx: number) => (
                    <motion.tr
                      key={idx}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.3 }}
                      className="bg-white border-b dark:bg-gray-800 text-xs dark:border-gray-700"
                    >
                      <th className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.baseFee}
                      </th>
                      {/* <td className="py-4 px-6 text-xs">{document?.referenceNumber}</td> */}

                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.newFeeAmount}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.createdAt ? (
                          <span>
                            {dateFormat(managementFeeIncrease?.increaseDate, {
                              weekday: true,
                              day: true,
                              month: true,
                              year: true,
                              hour: false,
                            })}
                          </span>
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.increasePercentage}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.increaseAmount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.reasonForIncrease}
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">{
                                            managementFeeIncrease?.createdAt ? (
                                                <span>{dateFormat(managementFeeIncrease?.nextIncreaseDate, { weekday: true, day: true, month: true, year: true, hour: false })}</span>
                                            ) : (
                                                <span>-</span>
                                            )
                                        }</td> */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.status}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                        {managementFeeIncrease?.createdAt ? (
                          <span>{dateFormat(managementFeeIncrease?.createdAt)}</span>
                        ) : (
                          <span>-</span>
                        )}
                      </td>

                      {userInfo?.role?.key !== "tenant" && (
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100 ">
                          <div className="flex space-x-2">
                            <Button
                              variant="filled"
                              // loading={removedmanagementFeeIncreases.isLoading && removedmanagementFeeIncreases?.originalArgs === managementFeeIncrease?.id}
                              className={`bg-primary text-white flex space-x-2 items-center`}
                              type="button"
                              onClick={() => openUpdateModal(managementFeeIncrease)}
                              classNames={{ label: "flex space-x-1" }}
                              size={"xs"}
                            >
                              <IconEdit size={20} strokeWidth={1.5} />
                            </Button>
                            <Confirmation
                              type={"danger"}
                              message={t("permanentDeleteMessage")}
                              onYes={() => {
                                deleteManagementFeeIncrease(managementFeeIncrease?.id as string)
                                close()
                              }}
                              header={t("permanentDeleteTitle")}
                            >
                              <Button
                                variant="filled"
                                loading={
                                  deleteManagementFeeIncreaseResponse.isLoading &&
                                  deleteManagementFeeIncreaseResponse?.originalArgs ===
                                  managementFeeIncrease?.id
                                }
                                className={`bg-danger text-white flex space-x-2 items-center`}
                                type="button"
                                classNames={{ label: "flex space-x-1" }}
                                size={"xs"}
                              >
                                <IconTrash size={20} strokeWidth={1.5} />
                              </Button>
                            </Confirmation>
                          </div>
                        </td>
                      )}
                    </motion.tr>
                  ),
                )}
            </tbody>
          </table>
          {!managementFeeIncreases?.data?.data?.length ? (
            <div className="w-full relative flex justify-center items-center h-56">
              <EmptyIcon />
            </div>
          ) : (
            <></>
          )}

          {managementFeeIncreases?.data && managementFeeIncreases?.data?.count > 0 && (
            <div className="w-full flex justify-end items-center mt-2 mb-2">
              <Pagination
                total={managementFeeIncreases?.data?.count as number}
                defaultPageSize={10}
                pageSize={[5, 10, 15, 20]}
                onPaginationChange={(skip: number, top: number) => {
                  setManagementFeeIncreaseCollection({
                    ...managementFeeIncreaseCollection,
                    skip: skip,
                    top: top,
                    filter: [
                      [
                        {
                          field: "leaseId",
                          operator: "=",
                          value: params?.id as string,
                        },
                      ],
                    ],
                  })
                }}
              />
            </div>
          )}
        </div>
      </div>

      <Modal
        opened={opened}
        onClose={close}
        size={"sm"}
        title={
          mode == "new"
            ? t("managementFeeIncreaseAction", { action: t("add") })
            : t("managementFeeIncreaseAction", { action: t("edit") })
        }
        centered
      >
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="flex w-full mt-20 space-x-4 justify-between ">
            <div className="w-full">
              <Select
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                clearable
                dropdownPosition="bottom"
                label={t("increaseType")}
                placeholder={t("increaseType")}
                data={[
                  { value: "Amount", label: t("amount") },
                  { value: "Percent", label: t("percent") },
                ]}
                value={type}
                onChange={(value: "Amount" | "Percent") => setType(value)}
              />

              {type == "Amount" ? (
                <TextInput
                  classNames={{ label: "dark:text-white" }}
                  className="w-full"
                  type="number"
                  error={
                    errors.increaseAmount &&
                    `${errors?.increaseAmount?.message}`
                  }
                  withAsterisk
                  label={t("increaseAmount")}
                  placeholder={t("increaseAmount")}
                  {...register("increaseAmount")}
                />
              ) : (
                <TextInput
                  classNames={{ label: "dark:text-white" }}
                  className="w-full"
                  type="number"
                  error={
                    errors.increasePercentage &&
                    `${errors?.increasePercentage?.message}`
                  }
                  withAsterisk
                  label={t("increasePercent")}
                  placeholder={t("increasePercent")}
                  {...register("increasePercentage")}
                />
              )}

              <TextInput
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                // type="number"
                error={
                  errors.reasonForIncrease &&
                  `${errors?.reasonForIncrease?.message}`
                }
                withAsterisk
                label={t("reasonForIncrease")}
                placeholder={t("reasonForIncrease")}
                {...register("reasonForIncrease")}
              />

              
              <Controller
                control={control}
                name="increaseDate"
                render={({ field }) => (
                  <DateInput
                    icon={<IconCalendar size={16} />}
                    className="w-full mt-3"
                    {...field}
                    // excludeDate={(edate) => {
                    //   if (edate.getFullYear() < date.getFullYear()) {
                    //     return true;
                    //   } else if (
                    //     edate.getFullYear() === date.getFullYear() &&
                    //     edate.getMonth() < date.getMonth()
                    //   ) {
                    //     return true;
                    //   } else {
                    //     if (
                    //       edate.getFullYear() <= date.getFullYear() &&
                    //       edate.getMonth() === date.getMonth() &&
                    //       edate.getDate() <= date.getDate()
                    //     ) {
                    //       return true;
                    //     } else {
                    //       return false;
                    //     }
                    //   }
                    // }}
                    error={
                      errors.increaseDate && `${errors.increaseDate?.message}`
                    }
                    label={t("increaseDate")}
                    withAsterisk
                  />
                )}
              />

              <div className="my-3">

                <Controller
                  control={control}
                  name="notifyTenant"
                  render={({ field }) => (
                    //@ts-ignore
                    <Switch
                      className={"my-1"}
                      checked={field.value}
                      // {...field}
                      onChange={(event: any) =>
                        field.onChange(event.currentTarget.checked)
                      }
                      label="Should we notify the tenant?"
                    />
                  )}
                />
              </div>

              <Textarea
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                error={errors.notes && `${errors?.notes?.message}`}
                // withAsterisk
                label={t("notes")}
                placeholder={t("notes")}
                {...register("notes")}
              />
            </div>
          </div>

          <div className="pt-8 flex justify-end">
            <Button
              variant="filled"
              className="bg-primary text-white"
              type="submit"
              classNames={{ label: "flex space-x-1" }}
              size={"xs"}
              loading={
                createManagementFeeIncreaseResponse.isLoading ||
                updateManagementFeeIncreaseResponse.isLoading
              }
            //  onClick={() => handleAssignDriver()}
            >
              <span>
                <IconDeviceFloppy size={22} strokeWidth={1.5} />
              </span>
              {t("submit")}
            </Button>
          </div>
        </form>
      </Modal>
    </>
  )
}
